import { Flex, Placeholder, Text } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import HeadingSection from "../components/HeadingSection";
import SuccessHeading from "../components/SuccessHeading";
import InquiryNotPossibleSection from "../GuestPortal/InquiryNotPossibleSection";
import { useReservationContext } from "../providers/ReservationProvider";
import { FinalizeBookingPayButton } from "./FinalizeBookingPayButton";
import { useEffect } from "react";

export default function FinalizeBookingPage() {
  const { t } = useTranslation();
  const params = useParams();
  const { reservation, loading, refetch } = useReservationContext();

  // Stalled pages in the background should refresh every minute to limit the number of double bookings.
  // We should not allow payments when the actual reservation is not in the "inquiry" state.
  useEffect(() => {
    const interval = setInterval(() => {
      if (reservation && reservation.status === "inquiry") {
        refetch();
      }
    }, 60 * 1000);

    return () => clearInterval(interval); // cleanup on unmount
  }, [refetch, reservation]); // depend on refetch so it's always up-to-date

  return (
    <>
      {loading && <Placeholder height={80}></Placeholder>}

      {reservation && !loading && (
        <Flex direction={"column"} gap={40}>
          {(reservation.status === "inquiryNotPossible" ||
            reservation.status === "cancelled") && (
            <InquiryNotPossibleSection
              arrival={reservation.checkinDate}
              departure={reservation.checkoutDate}
            />
          )}

          {(reservation.status === "inquiry" ||
            reservation.status === "new" ||
            reservation.status === "modified") && (
            <>
              <Flex direction={"column"}>
                {!reservation.paid && (
                  <HeadingSection
                    title={t("FinalizeBooking.Title")}
                    subtitle={t("FinalizeBooking.Subtitle")}
                  ></HeadingSection>
                )}
                {reservation.paid && (
                  <SuccessHeading
                    label={t("FinalizeBooking.SuccessTitle")}
                  ></SuccessHeading>
                )}

                <Flex>
                  <Text fontSize={16} color={"rgba(33, 52, 88, 0.7)"}>
                    {t("Reservation.Id")}: {params.reservationId}
                  </Text>
                </Flex>

                <Flex>
                  <Text fontSize={16} color={"rgba(33, 52, 88, 0.7)"}>
                    {" "}
                    {reservation.listingName}
                  </Text>
                </Flex>
                <Flex>
                  <Text fontSize={16} color={"rgba(33, 52, 88, 0.7)"}>
                    {" "}
                    {reservation.checkinDate} - {reservation.checkoutDate}
                  </Text>
                </Flex>
              </Flex>

              {!reservation.paid && (
                <Flex grow={1}>
                  <FinalizeBookingPayButton
                    reservation={reservation}
                  ></FinalizeBookingPayButton>
                </Flex>
              )}
            </>
          )}
        </Flex>
      )}
    </>
  );
}
